import React, { useState, useEffect, useRef } from 'react';
import { showToast } from '../Common/Messages';
import PopUp from '../Common/PopUp';
import SearchDocument from '../Common/SearchDocument';
import { parseToArray } from '../libs/Util';

const MenuSetting = (props) => {
    const [current, setCurrent] = useState(null);
   
    const [treeData, setTreeData] = useState(null);
    const [keyword, setKeyword] = useState("");
    const [module, setModule] = useState("");
    const [manualId, setManualId] = useState("");
    const [documents, setDocuments] = useState([]);
    const [documentsList, setDocumentsList] = useState([]);
    const [menuPath, setMenuPath] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [popupContent, setPopUpContent] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [filteredTree, setFilteredTree] = useState(null);
    const userId = props.userId;
    const inputModule = useRef(null);
    const titleRef = useRef(null);
    const inputTitleRef = useRef(null);

    useEffect(() => {
        if (props.mainRoute != null) {
            getCategoryList(props.mainRoute);
            setDocuments([]);
            setModule("");
            fetchDocumentMenu(props.subRoute ?? props.mainRoute);
            setMenuPath(props.subRoute ? `${props.mainRoute}/${props.subRoute}` : props.mainRoute);
            setSearchKeyword("");
        }
    }, [props.mainRoute, props.subRoute]);


    useEffect(() => {
        if (treeData != null && manualId !== '') {
            setTreeData((prevData) => updateDocuments(prevData, manualId, module, documents));
            updateDocumentsList(manualId, module, documents);
        }
    }, [module, documents]);

    useEffect(() => {
        setDocumentsList([]);
        setCurrent(null);
    }, [menuPath]);

    useEffect(() => {
        if (isEditing && inputTitleRef.current) {
            inputTitleRef.current.select();
        }
        if (isEditing) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isEditing]);

    useEffect(() => {
        if (searchKeyword.trim() === "") {
            setFilteredTree(treeData);
        } else {
            filterTree(treeData, searchKeyword);
        }
        // treeData 변경시?
    }, [searchKeyword, treeData]);

    const handleClickOutside = (e) => {
        if (titleRef.current && !titleRef.current.contains(e.target)) {
            setIsEditing(false); // 편집 모드 해제
        }
    };

    const handleTitleClick = () => {
        setIsEditing(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'module') {
            setModule(value);
        }
    };

    const onClickNode = (e, data) => {
        if (current && module === "") {
            if (manualId !== data.manualId) showToast('warning', "메뉴명을 입력해주세요.");
            inputModule.current?.focus();
            return;
        }
        if (data.children) {

        }
        e.preventDefault();
        setModule(data.module);
        setManualId(data.manualId);
        setDocuments(data.documents);
        setCurrent(data);
    };
    const getCategoryList = (menuname) => {
        fetch('datas/oper/categorytype.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json())
            .then(data => {
                getMenuType(menuname, data);
            }).catch(e => {
            });
    }

    const getMenuType = (menuname, categorys) => {
        fetch('datas/oper/menutype.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json()).then(data => {
                const result = data
                    .find(item => item.menuname === menuname)?.category || [];
                setCategoryList(result.map(x => {return {...x, sub: categorys.find(c => c.type === x.type)?.version ?? []}}));
            }).catch(e => {
            });
    };

    const getPath = (node, tree = treeData) => {
        // 내부 재귀 함수
        const searchPath = (datas, path) => {
            for (let data of datas) {
                // manualId가 일치하면 경로 반환
                if (data.manualId === node.manualId) {
                    return [...path, data.module];
                }
                // children이 있으면 재귀 탐색
                if (data.children) {
                    const result = searchPath(data.children, [...path, data.module]);
                    if (result) return result; // 경로가 발견되면 반환
                }
            }
            return null; // 탐색 실패 시 null 반환
        };
        // 탐색 시작
        const path = searchPath(tree.children, []) || [];

        // 마지막 요소를 제외한 경로 반환
        return path.slice(0, path.length - 1);
    };

    const saveMenuModule = async () => {
        if (documentsList.find(x => x.module === "")) {
            showToast('warning', "메뉴명이 입력되지 않은 메뉴가 존재합니다. 모두 입력후 다시 시도해주세요.");
            return;
        }
        const datas = documentsList.map(x => {
            return {
                ...x,
                module: x.module,
                nodePath: getPath(x)
            };
        });
        const body = {
            Documents: JSON.stringify(datas),
            MenuPath: menuPath,
            DevUserId: userId
        };

        const response = await fetch(`api/Document/SaveMenuModule`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.message === "Success" && result.data.errorMessage === undefined) {
            saveMenuTree();
            setDocumentsList([]);
            showToast('success', "저장 완료");
        } else if (result.data.errorMessage !== undefined) {
            showToast('danger', result.data.errorMessage[0].message);
        } else {
            showToast('danger', result.message);
        }
    };

    const updateDocuments = (data, manualId, module, newDocuments) => {
        if (data.manualId === manualId) {
            return { ...data, module: module, documents: newDocuments };
        }
        if (data.children) {
            return {
                ...data,
                children: data.children.map((child) =>
                    updateDocuments(child, manualId, module, newDocuments)
                )
            };
        }
        return data;
    };

    const updateDocumentsList = (manualId, module, documents) => {
        // 변경내용 체크 기능 작업 예정
        setDocumentsList((prevList) => {
            const existingIndex = prevList.findIndex((item) => item.manualId === manualId);

            if (existingIndex > -1) {
                // manualId가 동일한 경우 module과 documents를 업데이트
                const updatedList = [...prevList];
                updatedList[existingIndex] = { ...updatedList[existingIndex], module, documents };
                return updatedList;
            } else {
                // manualId가 없으면 새 항목 추가
                const location = treeData.location;
                return [...prevList, { manualId, module, location, documents }];
            }
        });
    };

    const btnOnPopup = (e, type) => {
        if (e !== undefined) {
            e.stopPropagation();
        }
        if (type === 'doc') {
            setPopUpContent(
                <SearchDocument addItem={addItem} removeItem={removeItem} documents={documents} keyword={keyword} setKeyword={setKeyword} fnBtnOnPopup={btnOnPopup} />
            );
        } else {
            setKeyword('');
            setPopUpContent(null);
        }
    }

    const saveMenuTree = async () => {
        const body = {
            Module: module,
            MenuPath: menuPath,
            MenuTreeJson: JSON.stringify(treeData, null, 2)
        };
        const response = await fetch('api/Document/SaveMenuTree', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200 && result.message === "Success") {
            const data = result.data;
            const status = result.message;
            if (status === "Success") {
                if (data) {
                    setTreeData(data);
                }
            } else {
                setTreeData(null);
            }
        } else {
            showToast('danger', result.message);
        }
    };

    const fetchDocumentMenu = (className) => {
        fetch(`datas/menu/${className}.json`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        })
            .then((response) => {
                if (!response.ok) {
                    setTreeData(null);
                    return null;
                }
                return response.json();
            })
            .then((data) => {
                if (data) {
                    setTreeData(data);
                }
            })
            .catch((error) => {
                console.error("문서 읽기 오류:", error);
                setTreeData(null);
            });
    };

    const addItem = (item) => {
        if (documents) {
            // documents에 동일한 docId가 있는지 확인
            const exists = documents.some((dataItem) => dataItem.docId === item.docId);
            if (!exists) {
                const newItem = {
                    title: item.title,
                    docBox: item.docBox,
                    docBoxPath: item.docBoxPath,
                    docId: item.docId,
                    version: item.version,
                    access: item.access,
                    tag: item.tag
                };
                setDocuments((prevDocuments) => [...prevDocuments, newItem]);
            }
        }
    };

    const removeItem = (item) => {
        if (documents) {
            setDocuments((prevDocuments) =>
                prevDocuments.filter((data) => data.docId !== item.docId)
            );
        }
    };

    const updateDocumentField = (index, field, value) => {
        setDocuments(prevDocuments =>
            prevDocuments.map((doc, i) =>
                i === index ? { ...doc, [field]: value } : doc
            )
        );
    };

    const addSubClick = (e, node) => {
        e.stopPropagation();
        const newChild = {
            "module": "새문서" + new Date().getTime(),
            "manualId": "M" + new Date().getTime(),
            "documents": []
        };

        const addChildNode = (data, nodeId) => {
            if (data.manualId === nodeId) {
                if (!data.children) data.children = [];
                data.children.push(newChild);
            } else if (data.children) {
                data.children.forEach(child => addChildNode(child, nodeId));
            }
        };

        const updatedTree = { ...treeData };
        addChildNode(updatedTree, node.manualId);
        setTreeData(updatedTree);
    };

    const removeSubClick = (e, node) => {
        e.stopPropagation();

        const removeChildNode = (data, nodeId) => {
            if (!data.children) return;
            data.children = data.children.filter(child => child.manualId !== nodeId);
            if (data.children.length === 0) delete data.children;
            else data.children.forEach(child => removeChildNode(child, nodeId));
        };

        const updatedTree = { ...treeData };
        if (updatedTree.manualId === node.manualId) {
            setTreeData(null);
        } else {
            removeChildNode(updatedTree, node.manualId);
            setTreeData(updatedTree);
        }
        setDocumentsList(documentsList.filter(document => document.manualId !== node.manualId));
    };

    const changeCollapse = (e, data) => {
        e.preventDefault();
        const button = e.currentTarget;
        const ul = button.closest('li').querySelector('ul');

        if (data.collapsed) {
            ul.style.display = 'block';
            data.collapsed = false;
        } else {
            ul.style.display = 'none';
            data.collapsed = true;
        }
    };

    const filterTree = (tree, keyword) => {
        const filterTree = (nodes, query) => {
            if (!query) return nodes;
            
            return nodes
                .map((node) => {
                if (node.module.toLowerCase().includes(query.toLowerCase())) {
                    return node;
                }
                if (node.children) {
                    const filteredChildren = filterTree(node.children, query);
                    if (filteredChildren.length > 0) {
                        return { ...node, children: filteredChildren };
                    }
                }
                return null;
                })
                .filter(Boolean);
        };
        setFilteredTree({...tree, children: filterTree(tree.children, keyword)});
    }

    const [draggedNode, setDraggedNode] = useState(null);
    const [dragOverNodeId, setDragOverNodeId] = useState(null);
    const [dropAction, setDropAction] = useState({});

    // 자기 자신 또는 children으로 드래그 방지
    const isDescendant = (parent, child) => {
        if (parent.manualId === child.manualId) return true;
        else if (!parent.children) return false;
        for (const node of parent.children) {
            if (node.manualId === child.manualId || isDescendant(node, child)) {
                return true;
            }
        }
        return false;
    };

    const updateNode = (e, data, tree) => {
        e.preventDefault();
        updateDocumentsList(data.manualId, data.module, data.documents);
        if (data.children) {
            for (const child of data.children) {
                updateNode(e, child, tree);
            }
        }
    };

    const onDragStart = (e, node) => {
        e.stopPropagation();
        setDraggedNode(node);
    };

    const onDrop = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        if (!draggedNode || draggedNode.manualId === targetNode.manualId) return;

        // 자기 자신의 child로 드래그 방지
        if (isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        setTreeData((prevData) => {
            const removeNode = (nodes, nodeId) => {
                const result = [];
                let removedNode = null;
                for (const node of nodes) {
                    if (node.manualId === nodeId) {
                        removedNode = node;
                    } else if (node.children) {
                        const { updatedChildren, removed } = removeNode(node.children, nodeId);
                        if (updatedChildren.length === 0) {
                            delete node.children;
                        } else {
                            node.children = updatedChildren;
                        }
                        result.push(node);
                        if (removed) removedNode = removed;
                    } else {
                        result.push(node);
                    }
                }
                return { updatedChildren: result, removed: removedNode };
            };

            const addNode = (nodes, targetId, newNode, position) => {
                return nodes.map((node) => {
                    if (node.manualId === targetId) {
                        if (dropAction.child) {
                            node.children = [...(node.children || []), newNode];
                        } else if (dropAction.above) {
                            return [newNode, node];
                        } else if (dropAction.below) {
                            return [node, newNode];
                        }
                    } else if (node.children) {
                        node.children = addNode(node.children, targetId, newNode, position);
                    }
                    return node;
                }).flat();
            };

            const { updatedChildren, removed } = removeNode(prevData.children, draggedNode.manualId);
            if (!removed) return prevData;

            const position = dropAction.above || dropAction.below || dropAction.child;

            let newData = prevData;
            if (position) {
                newData = {
                    ...prevData,
                    children: addNode(updatedChildren, targetNode.manualId, removed, dropAction),
                };
            }

            updateNode(e, draggedNode, newData);
            return newData;
        });

        setDraggedNode(null);
        setDragOverNodeId(null);
        setDropAction({});
    };

    const onDragOver = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        // 자기 자신의 child로 드래그 방지
        if (draggedNode && isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        const rect = e.target.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const height = rect.height;

        if (offsetY < height * 0.25) {
            // 위 가장자리: move 위
            setDropAction({ above: true, below: false, child: false });
        } else if (offsetY > height * 0.75) {
            // 아래 가장자리: move 아래
            setDropAction({ above: false, below: true, child: false });
        } else {
            // 중앙: child 포함
            setDropAction({ above: false, below: false, child: true });
        }

        setDragOverNodeId(targetNode.manualId);
    };

    const highlightMatch = (text, query) => {
        if (!query) return text;
    
        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);
    
        return parts.map((part, i) =>
            regex.test(part) ? <mark key={i}>{part}</mark> : part
        );
    };

    const removeStyle = {
        marginRight: '20px'
    };

    const renderTree = (data, depth = 1) => (
        <>
            {!data.children && (
                <a className={`depth-${depth} last-depth`}
                    href={() => { }}
                    onClick={e => onClickNode(e, data)}>
                    {data.children && (
                        <div className={`btn-expand ${data.collapsed ? 'collapse' : ''}`}><i className="icoKdc16 expand"></i></div>
                    )}
                    <i className="icoKdc20 document icon-folder"></i>
                    <span className="txt folder">{highlightMatch(data.module, searchKeyword)}</span>
                    {data.documents && data.documents.length > 0 && (
                        <div className="icoKdc20 link" title="문서있음"></div>
                    )}
                    <div className="icoKdc20 add btn-add-folder" title="하위추가" onClick={e => addSubClick(e, data)}><i className="i-manual-add-folder"></i></div>
                    <div className="icoKdc20 delete" title="삭제" onClick={e => removeSubClick(e, data)} style={removeStyle}><i className="i-manual-delete-folder"></i></div>
                </a>
            )}
            {data.children && (
                <ul style={{ display: `${data.collapsed ? 'none' : 'block'}` }}>
                    {data.children.map((child, index) => (
                        <li
                            key={index}
                            draggable
                            onDragStart={(e) => onDragStart(e, child)}
                            onDrop={(e) => onDrop(e, child)}
                            onDragOver={(e) => onDragOver(e, child)}
                            style={{
                                borderTop: dragOverNodeId === child.manualId && dropAction.above ? "2px solid #007bff" : "none",
                                borderBottom: dragOverNodeId === child.manualId && dropAction.below ? "2px solid #007bff" : "none",
                                backgroundColor: dragOverNodeId === child.manualId && dropAction.child ? "#d1e7ff" : "transparent",
                            }}
                        >
                            <a className={`depth-${depth} ${!child.children ? 'last-depth' : ''} ${child.manualId === manualId ? 'on' : ''}`}
                                href={() => { }}
                                onClick={e => onClickNode(e, child)}>
                                {child.children && (
                                    <div className={`btn-expand ${child.collapsed ? 'collapse' : ''}`} onClick={(e) => changeCollapse(e, child)}><i className="icoKdc16 expand"></i></div>
                                )}
                                <i className="icoKdc20 document icon-folder"></i>
                                <span className="txt folder">{highlightMatch(child.module, searchKeyword)}</span>
                                {child.documents && child.documents.length > 0 && (
                                    <div className="icoKdc20 link" title="문서있음"></div>
                                )}
                                <div className="icoKdc20 add btn-add-folder" title="하위추가" onClick={e => addSubClick(e, child)}><i className="i-manual-add-folder"></i></div>
                                <div className="icoKdc20 delete" title="삭제" onClick={e => removeSubClick(e, child)} style={removeStyle}><i className="i-manual-delete-folder"></i></div>
                            </a>
                            {child.children && renderTree(child, depth + 1)}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );

    return (
        <div className="content-scroll">
            <div className="content">
                <div className='doc-list-wrap'>
                    <div class="doc-list-title-wrap">
                        <h3 className='list-title'>{treeData?.module}</h3>
                        <button className="btn-add" onClick={e => addSubClick(e, treeData)}><i className="icoKdc20 add"></i></button>
                    </div>
                    <div className='doc-list'>
                        <div className='doc-search'>
                            <i className='icoKdc24 magnifier-b'></i>
                            <input placeholder={"제목 필터"} value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} />
                        </div>
                        <div className="manual-editor" style={{ position: 'relative' }}>
                            {filteredTree !== null && (
                                <div className="edit-content view-mode">
                                    <div className="left-ctgr menu-list">
                                        <div className="ctgr-tree" style={{ height: 'calc(100vh - 250px)' }}>
                                            <ul className="tree" style={{ display: 'block' }}>
                                                <li>{renderTree(filteredTree)}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='menu-cnts-wrap'>
                    <div className="doc-title-wrap" ref={titleRef}>
                        {isEditing ? (
                            <div className="doc-title-edit">
                                <input
                                    type="text"
                                    name="module"
                                    className="doc-title"
                                    value={module}
                                    onChange={handleInputChange}
                                    ref={inputTitleRef}
                                />
                            </div>
                        ) : (
                            <div className="doc-title-default" onClick={handleTitleClick}>
                                <h3 className="doc-title">{module}</h3>
                                <button className="btn-edit">
                                    <i className="icoKdc20 edit"></i>
                                </button>
                            </div>
                        )}
                        <button className="btn-save" onClick={() => saveMenuModule()}>저장</button>
                    </div>
                    <h4 className='div-title'>연결할 문서 선택</h4>
                    <div className="doc-search">
                        <input className="search-input" name="keyword" value={keyword} onChange={handleInputChange} onKeyUp={(e) => e.key === 'Enter' && btnOnPopup(e, 'doc')} placeholder='문서 검색' />
                        <i className="icoKdc32 magnifier-32" onClick={(e) => btnOnPopup(e, 'doc')}></i>
                    </div>
                    <h4 className='div-title'>선택된 문서</h4>
                    <div className='doc-selected'>
                        <ul className='doc-selected-list'>
                            {documents && documents.length > 0 && (
                                documents.map((item, i) => (
                                    <li key={i} className='doc-selected-box'>
                                        <div className="doc-selected-box-title">
                                            <div className="doc-link">
                                                <p className='doc-selected-title'>{item.title}</p>
                                                <i className='icoKdc20 seemore-m'></i>
                                            </div>
                                            <button className='btn-delete' onClick={() => removeItem(item)}>
                                                <i className='icoKdc20 delete'></i>
                                            </button>
                                        </div>
                                        <div className='doc-selected-box-cnts'>
                                            <div className="option-top-wrap">
                                                <div className='option'>
                                                    <label className='option-label'>제품군</label>
                                                    <select className='option-top' value={item.product || ''} onChange={(e) => updateDocumentField(i, 'product', e.target.value)}>
                                                        <option value="">전체</option>
                                                        {categoryList.map((category, index) => (
                                                            <option key={index} value={category.type}>
                                                                {category.type}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='option'>
                                                    <label className='option-label'>버전</label>
                                                    <select className='option-top' value={item.version || ''} onChange={(e) => updateDocumentField(i, 'version', e.target.value)}>
                                                        <option value="">전체</option>
                                                        {categoryList.find(cate => cate.type === item.product)
                                                            ?.sub?.map((sub, subIndex) => (
                                                                <option key={subIndex} value={sub}>
                                                                    {sub}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='option'>
                                                <label className='option-label'>태그</label>
                                                <p className="tags">{item.tag ? parseToArray(item.tag).join(',') : ""}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                </div>
                <PopUp content={popupContent} setContent={setPopUpContent} />
            </div>
        </div>
    );
};

export default MenuSetting;